import {PKMimeTypes} from '../types';

const MimeType: PKMimeTypes = {
  HLS: ['application/x-mpegurl', 'application/vnd.apple.mpegurl'],
  DASH: ['application/dash+xml'],
  PROGRESSIVE: ['video/mp4'],
  SMOOTH_STREAMING: ['application/vnd.ms-sstr+xml']
};

export {MimeType};
